import { createRoot } from 'utils/react-shim'

import Site from 'application/site'
import setupWebComponents from 'shared/webcomponents'

function renderApp(RootComponent) {
  const rootElement = document.getElementById('root')
  if (rootElement) {
    const root = createRoot(rootElement)
    root.render(<RootComponent />)
  }
}

setupWebComponents()
renderApp(Site)
